<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Banners Ads</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->
          <div
            class="modal fade bd-example-modal-lg"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl">
              <div class="modal-content">
                <Areaofinterest
                  :category_id="category_id"
                  :category="categories"
                  @clicked="onClickChild"
                />
              </div>
            </div>
          </div>
          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <form @submit.prevent="updatebanner()" method="post">
                  <div class="row">
                    <div class="col-md-12 add_top_30">
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Expire Date</label>
                            <date-picker
                              v-model="expire_date"
                              :config="datepickerconfig"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Location</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="location"
                            />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label>Pincode</label>
                            <input
                              class="form-control"
                              type="number"
                              v-model="pincode"
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Upload Banner Photos</label>
                            <div class="form-group">
                              <div>
                                <input
                                  class="form-control"
                                  ref="file"
                                  multiple
                                  type="file"
                                  @change="onGalleryChange"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div
                              class="col-md-2"
                              v-for="galleryimages in galleryimage"
                              :key="galleryimages.id"
                            >
                              <img
                                :src="`http://localhost:8082/assets/user/vendorbanner/${galleryimages}`"
                                style="width: 100%"
                                class="mt-1"
                              />
                              <a
                                href="javascript:void(0);"
                                class="ml-3"
                                @click="
                                  removeImage(
                                    galleryimages.id,
                                    galleryimages.link
                                  )
                                "
                                ><i class="fa fa-trash"></i
                              ></a>
                            </div>
                          </div>
                          <div class="row mt-4">
                            <div class="col-md-12">
                              <div class="form-group">
                                <h5>Category</h5>
                                <a
                                  @click="openLoginModal()"
                                  href="javascript:void(0);"
                                  >Edit</a
                                >
                                <div
                                  class="form-check category"
                                  v-for="cat in categories"
                                  :key="cat.id"
                                >
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :value="cat.category_id"
                                    v-model="category_id"
                                  />
                                  <label class="form-check-label" for="">{{
                                    cat.category
                                  }}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /row-->

                      <!-- /row-->
                      <div class="row">
                        <div class="col-md-12">
                          <alert
                            transition="slide-y-transition"
                            v-if="msg"
                            :msg="msg"
                            :classAlert="classAlert"
                          ></alert>

                          <div id="pass-info" class="clearfix"></div>
                          <center>
                            <button
                              type="submit"
                              class="btn_1 rounded add_top_30 mb-3"
                            >
                              Submit
                            </button>
                          </center>
                        </div>
                      </div>

                      <!-- /row-->
                    </div>
                  </div>
                </form>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
import Alert from "@/cmps/Alert";
import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import Sidebar from "@/layouts/Sidebar.vue";
import moment from "moment";
import Areaofinterest from "../components/Areaofinterest.vue";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      msg: null,
      expire_date: "",
      classAlert: null,
      profileDetails: [],
      catOptions: [],
      subCatOptions: [],
      location: "",
      pincode: "",
      searchcat: {
        categories: [],
        subcategories: [],
      },
      categories: [],
      datepickerconfig: {
        format: "DD/MM/YYYY",
        useCurrent: false,
        minDate: new Date(),
        maxDate: new Date().setMonth(new Date().getMonth() + 1),
      },
      galleryimage: [],
      login_id: null,
      files: [],
      category_id: [],
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
    Alert,
    Areaofinterest,
  },
  beforeMount() {
    this.checkToken();
    this.getParentCategories();
    this.getbannerdetails();
  },

  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },
    openLoginModal() {
      window.$(".bd-example-modal-lg").modal("show");
    },
    onClickChild(value, id) {
      // someValue

      this.categories = value;
      this.category_id = id;
    },
    getbannerdetails() {
      let id = this.$router.currentRoute.params.id;
      const token = "Bearer " + localStorage.getItem("token");
      // alert(id);
      API.get("Banner/get_banner_details/" + id, {
        headers: { Authorization: token },
      })
        .then((res) => {
          res.data.data.forEach((value) => {
            this.expire_date = moment(value.expire_date, "YYYY-MM-DD").format(
              "DD/MM/YYYY"
            );
            this.location = value.location;
            this.pincode = value.pincode;
            this.galleryimage.push(value.banner_image);
            this.categories = value.banner_categories;
          });
          this.categories.forEach((value) => {
            console.log(value);
            this.category_id.push(value.category_id);
          });
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    getParentCategories() {
      API.get("categories/parent_services_select2list")
        //.get("categories/parent_services")
        .then((res) => {
          this.catOptions = res.data.data;
          // this.search = this.search.categories;
          console.log(res.data.data);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    setSubCategory(categoryId, mode) {
      //alert(categoryId);
      // let selSubCat = this.search.subcategories;
      API.get(
        "categories/parent_services_select2list/" + window.btoa(categoryId)
      )
        //.get("categories/parent_services")
        .then((res) => {
          if (mode == "push") {
            res.data.data.forEach((val) => {
              console.log("val=" + JSON.stringify(val));
              this.subCatOptions.push(val);
              //this.subCatOptions.concat(res.data.data);
            });

            //console.log("sub cat options=" + this.subCatOptions);
          } else {
            //this.search.subcategories.push(res.data.data);
            res.data.data.forEach((val) => {
              this.subCatOptions.splice(this.subCatOptions.indexOf(val.id), 1);
            });
          }
          this.searchcat.subcategories = [];
          // this.emitFilterRequest();
          //this.loadNearbyOffers(this.search);
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
    catSelectEvent(e) {
      var sel = e.selected;
      if (sel) {
        this.setSubCategory(e.id, "push");
        this.searchcat.categories.push(e.id);
      } else {
        this.setSubCategory(e.id, "remove");
        this.searchcat.categories.splice(
          this.searchcat.categories.indexOf(e.id),
          1
        );
      }
    },
    subcatselectEvent(e) {
      var sel = e.selected;
      //alert(sel + " " + e.id + " " + e.text + " " + e.selected);
      if (sel) {
        this.searchcat.subcategories.push(e.id);
      } else {
        this.searchcat.subcategories.splice(
          this.searchcat.subcategories.indexOf(e.id),
          1
        );
      }
      //this.loadNearbyOffers(this.search);
    },
    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },

    updatebanner() {
      const form = new FormData();
      form.append("role_id", this.roleId);
      form.append("expiredate", this.expire_date);
      form.append("location", this.location);
      form.append("category_id", this.category_id);
      form.append("pincode", this.pincode);
      if (this.files != null) {
        for (let i = 0; i < this.files.length; i++) {
          form.append("image[]", this.files[i]);
        }
      }
      API.post(`Banner/updatebanner/${this.$route.params.id}`, form, {
        headers: { Authorization: this.token },
      })
        .then((res) => {
          if (res.data.status == 200) {
            this.msg = "Your Banner Added Successfully";
            setTimeout(() => {
              this.msg = "";
            }, 3000);
            this.classAlert = "success";
            this.$router.push("/banner-list");
          } else {
            this.msg = res.data.messages;
            this.classAlert = "danger";
          }
        })
        .catch((err) => {
          this.msg = err.response.data.messages.error;
          setTimeout(() => {
            this.msg = "";
          }, 3000);
          this.classAlert = "danger";
        });
      //axios
    },

    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0]);
      this.profile_img = files[0];
    },
    onGalleryChange() {
      this.files = this.$refs.file.files;
    },
    createImage(file) {
      this.image = new Image();
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100%;
}
</style>